// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_-_-record-it-components-src-pageLayout-SynchronizationStatusSidebar-__contentWrapper"};